import { ApiActions } from '../../constants/ApiActions';
import { Map } from '../../lib/ImmutableUtils';
import { createReducer } from '../../lib/ReducerUtils';

const INITIAL_STATE = Map<$TSFixMe>({});
export type EntitiesSeedsState = typeof INITIAL_STATE;

export default createReducer(INITIAL_STATE, {
  [ApiActions.CREATE_STATION_SUCCESS]: saveSeedData,
  [ApiActions.FETCH_STATIONS_SUCCESS]: saveSeedData,
  [ApiActions.GET_SEEDS_SUCCESS]: saveSeedData,
  [ApiActions.GET_STATION_DETAILS_SUCCESS]: saveSeedData,
});

// CASE FUNCTIONS

function saveSeedData(state: EntitiesSeedsState, action: $TSFixMe): EntitiesSeedsState {
  return state.mergeDeep(action.response.entities.seeds);
}
